module.exports = __webpack_public_path__ + "static/media/donna.6093f3eb.jpg";